// extracted by mini-css-extract-plugin
export var text = "_ap-0";